import { TabItem } from '@app/data/types';
import { Endpoints } from '@data/consts';

const tabs: TabItem[] = [
    { icon: 'saved', value: Endpoints.TASK_DELIVERABLES_ALL, label: 'All deliverables' },
    { icon: 'chart', value: Endpoints.TASK_DELIVERABLES_APPROVED, label: 'Pending approval' },
];

export default tabs;
